// Gate for the signed-in part of the app. No session → the Login screen.
// `/login` and `/join/:token` are public and must NOT be wrapped in this.

import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { useT } from "../lib/LocaleContext";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();
  const location = useLocation();
  const t = useT();

  if (loading) {
    return (
      <main className="screen screen--center">
        <p className="muted">{t.common.loading}</p>
      </main>
    );
  }
  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
